import { makeStyles } from "@material-ui/core/styles";
import homePageStyle from "assets/jss/page/index/style.js";
import { BlogSection } from "@components/layout/blog/widget/blogSection.js";
import * as React from 'react';
export default {
  makeStyles,
  homePageStyle,
  BlogSection,
  React
};